import {Load} from "./Load";
import {Basic} from "./Basic";

export class Filter
{
    static initialize(el)
    {
        Filter.calendarFilters = Filter.get_calendarFilters(el);
        Filter.category = Filter.get_category(el);
        Filter.searchTerm = Filter.get_searchTerm(el);
        if(el)
        {
            Filter.url = el.href ? el.href : document.location.pathname;
        }
    }

    static process(el, type)
    {
        Filter.initialize(el);
        Filter.load(type);
    }

    static get_calendarFilters(el)
    {
        const filters = {};
        const filterContainer = document.body.querySelector('.w__calendar--filter');
        if(filterContainer)
        {
           if(el)
           {
               const filterParent = el.closest('.w__calendar--filter-ul');

               if(filterParent)
               {
                   if(el.classList.contains('active'))
                   {
                       el.classList.remove('active');
                       filterParent.classList.remove('active');
                   }
                   else
                   {
                       el.classList.add('active');
                       filterParent.classList.add('active');
                   }
               }
           }

           const activeFilters = filterContainer.querySelectorAll('.w__js-button.active');
           for(let i = 0; i < activeFilters.length; i++)
           {
               filters[activeFilters[i].dataset.type] = parseInt(activeFilters[i].dataset.value);
           }
        }
        return filters;
    }

    static load(type)
    {
        Load.post({
            f: type,
            calendarFilters: Filter.calendarFilters,
            filter: Filter.category,
            search: Filter.searchTerm,
            url: Filter.url
        }).then(r =>
        {
            Filter.display_activeFilters(r['filters']);
            Basic.update_page(r, Filter.url,true);
        }).catch(r =>
        {
            console.error(r, Filter.url);
        });
    }

    static display_activeFilters(filters)
    {
        let items = document.body.querySelectorAll('.w__calendar--filter .w__button');
        let type, el, li, value;
        for(let i=0; i<items.length; i++)
        {
            if(items[i].dataset.type)
            {
                el = items[i];
                li = el.parentElement;
                type = el.dataset.type;
                value = parseInt(el.dataset.value);

                li.classList.remove('mod--last')

                if(filters &&
                  (filters[type][value] ||
                  (type === 'ensemble' &&
                   filters['ensemble'][4] &&
                   (el.dataset.value === '1,4' || el.dataset.value === '3,4'))))
                {
                    li.classList.remove('mod--off');
                    li.classList.add('mod--on');
                }
                else
                {
                    li.classList.add('mod--off');
                    li.classList.remove('mod--on');
                }
            }
        }
        let uls = document.body.querySelectorAll('.w__calendar--filter .w__calendar--filter-ul');
        for(let i=0; i<uls.length; i++)
        {
            const lastEl = uls[i].querySelectorAll('.mod--on');
            if(lastEl.length)
            {
                lastEl[lastEl.length - 1].classList.add('mod--last');
            }
        }
    }

    static get_category(el)
    {
        let filter;

        if(el && el.classList.contains('w__search--filter'))
        {
            Basic.set_filterMarker(el);
            filter = el.dataset.filter;
        }
        else
        {
            const filterEl = document.body.querySelector('.w__search--filter-cell .w__search--filter.active');
            if(filterEl)
            {
                filter = filterEl.dataset.filter
            }
        }

        return filter ? filter : null;
    }

    static get_searchTerm(el)
    {
        let searchTerm = '';
        const searchField = document.body.querySelector('.w__search--filter-cell .w__input--search');

        if(searchField)
        {
            if(el && el.dataset.action === 'reset-search')
            {
                searchField.value = '';
            }

            searchTerm = searchField.value.trim();

            if(searchTerm)
            {
                searchField.closest('.w__search--filter-item').classList.add('search-active');
            }
            else
            {
                searchField.closest('.w__search--filter-item').classList.remove('search-active');
            }
        }

        return searchTerm;
    }
}